/**
 * Created by valerasiestov on 24.11.15.
 */


if (!window.module) {
    window.module = {};
}

module.contentTabs = (function (global) {
    "use strict";

    var controls = {},
        handlers = {
            clickItem: function (event) {
                event.preventDefault();

                var list = controls.list,
                    count = list.length,
                    i,
                    block,
                    temp;

                if (this.classList.contains('active')) {
                    return;
                }

                for (i = 0; i < count; i++) {
                    list[i].classList.remove('active');
                    block = document.querySelector(list[i].getAttribute('data-id'));
                    block.classList.remove('active');
                }

                this.classList.add('active');
                block = document.querySelector(this.getAttribute('data-id'));
                block.classList.add('active');

                if (list[count - 1].classList.contains('active')) {
                    temp = document.querySelector('.offers__info-triangle');
                    if (temp) {
                        temp.style.display = 'none';
                    }

                    temp = document.querySelector('.offers__info-red');

                    if (temp) {
                        temp.style.display = 'none';
                    }
                } else {
                    temp = document.querySelector('.offers__info-triangle');
                    if (temp) {
                        temp.style.display = '';
                    }

                    temp = document.querySelector('.offers__info-red');

                    if (temp) {
                        temp.style.display = '';
                    }
                }

                if (module.sidebar) {
                    module.sidebar.changeContent();
                }
            }
        };

    function setEventList() {
        global.addEvents(controls.list, 'click', handlers.clickItem);
    }

    function getControls() {
        controls.list = document.querySelectorAll('.page__offers ul li a');
    }

    function init(params) {
        getControls();
        setEventList();
    }

    return {
        init: init
    };

}(DALGAKIRAN.global));

window.addEventListener('DOMContentLoaded', function () {

    module.contentTabs.init({

    });

}, false);
 